import { CustomExtender } from '#/CoreFrameInterfaces';
import ChangeHandler from '@/Utility/ChangeHandler';

export default class TrackChangeExtender implements CustomExtender {

    public AddToKnockout() {
        ko.extenders.trackChange = (target: KnockoutObservable<any>, track: boolean): KnockoutObservable<any> => {
            if (track) {
                target.hasValueChanged = ko.observable(false);
                target.hasDirtyProperties = ko.observable(false);

                target.isDirty = ko.computed(() => {
                    return target.hasValueChanged() || target.hasDirtyProperties();
                });

                let unwrapped = target();
                if (unwrapped instanceof Object) {
                    ChangeHandler.traverseObservables(unwrapped, (obj) => {
                        ChangeHandler.applyChangeTrackingToObservable(obj.value);

                        obj.value.isDirty.subscribe((isdirty) => {
                            if (isdirty) {
                                target.hasDirtyProperties(true);
                            }
                        });
                    });
                }

                target.originalValue = target();
                target.subscribe((newValue) => {
                    target.hasValueChanged(TrackChangeExtender.hasValueBeenChanged(newValue, target.originalValue));
                    target.hasValueChanged.valueHasMutated();
                });

                if (!target.getChanges) {
                    target.getChanges = (newObject) => {
                        let obj = target();
                        if (obj instanceof Object) {
                            if (target.hasValueChanged()) {
                                return ko["mapping"].toJS(obj);
                            }
                            return ChangeHandler.getChangesFromModel(obj);
                        }

                        return target();
                    };
                }

                if (!target.onChange) {
                    target.onChange = () => {
                        target.hasValueChanged(true);
                    };
                }

                if (!target.commit) {
                    target.commit = () => {
                        target.originalValue = target();

                        target.hasValueChanged(false);
                        target.hasDirtyProperties(false);
                    };
                }

                if (!target.revert) {
                    target.revert = () => {
                        target(target.originalValue);

                        target.hasValueChanged(false);
                        target.hasDirtyProperties(false);
                    };
                }
            }

            return target;
        };
    }

    private static hasValueBeenChanged(newValue, oldValue): boolean {
        // in the case of arrays, the content must be compared
        if (Array.isArray(newValue) && Array.isArray(oldValue))
            return JSON.stringify(newValue) != JSON.stringify(oldValue);

        return newValue != oldValue;
    }

}